import { Project } from 'data/projects';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import projectService from 'services/project';

interface ActionProjectDropdownItemsProps {
  project: Project;
}

const ActionProjectDropdownItems = ({
  project
}: ActionProjectDropdownItemsProps) => {
  const navigate = useNavigate();

  const handleDeleteProjectClick = async () => {
    projectService.deleteProject(project).then(data => {
      if (data) {
        console.log('Success:', 'project deleted');
        window.location.reload();
      } else {
        console.error('Error:', 'problem deleting project ' + project.title);
      }
    });
  };

  const handleViewProjectClick = async () => {
    navigate(`/apps/project-management/project-details/${project.projectId}`);
  };

  return (
    <>
      <Dropdown.Item eventKey="1" onClick={() => handleViewProjectClick()}>
        View
      </Dropdown.Item>
      {/* <Dropdown.Item eventKey="2">Export</Dropdown.Item> */}
      <Dropdown.Divider />
      <Dropdown.Item
        eventKey="4"
        className="text-danger"
        onClick={() => handleDeleteProjectClick()}
      >
        Delete
      </Dropdown.Item>
    </>
  );
};

export default ActionProjectDropdownItems;
